import { defineMessages } from 'react-intl';

export default defineMessages({
  importContent: 'Import content',

  structure: 'Structure',
  block: 'Block',
  pageBreak: 'Page break',
  text: 'Text',
  intro: 'Invitation',

  questionTypes: 'Question types',
  radio: 'Single choice',
  checkbox: 'Multiple choice',
  field: 'Text answer',
  zipCode: 'Zip code',
  country: 'Country',
  sentiment: 'Sentiment',
  thumbs: 'Thumbs',
  contactMe: 'Contact Me',
  nps: 'NPS',
});
